<template>
  <modal :show.sync="modals.modal1" footerClasses="text-right" :largeModal="false">
    <h6 slot="header" class="modal-title text-success font-weight-bold" id="modal-title-default">Tambah Pajak Walet</h6>
    <div class="d-block">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form ref="form" @submit.stop.prevent="handleSubmit(submit)">
          <div class="alert alert-danger" v-if="error_msg.length > 0">
            <strong>Warning!</strong> Perbaiki hasil input Anda :
            <ul>
              <li v-for="text in error_msg" :key="text">{{ text }}</li>
            </ul>
          </div>
          <div class="mb-5">
            <!-- /.page-header -->
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12 col-sm-12">
                    <div class="form-group">
                      <ValidationProvider name="NPWPD" rules="required" v-slot="{ errors }">
                        <label for="NPWPD">PAJAK - OBJEK PAJAK</label>
                        <v-select :options="registrations" v-model="form.registration_id"
                          :reduce="(registration) => registration.id" :getOptionLabel="(registration) =>
                            registration.business.name +
                            ' - ' +
                            registration.npwpd
                            " class="form-control" :class="[
    { 'is-valid': !errors[0] },
    { 'is-invalid': errors[0] },
  ]" placeholder="~~ Pilih NPWPD ~~" @input="get_texes()"></v-select>
                        <div class="text-danger invalid-feedback" style="display: block" v-if="errors[0]">{{ errors[0] }}
                        </div>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 col-sm-12">
                    <div class="form-group">
                      <ValidationProvider name="Rekening Pajak" rules="required" v-slot="{ errors }">
                        <label for="Rekening Pajak">Rekening Pajak</label>
                        <v-select :options="taxes" v-model="selectedTaxes"
                          :getOptionLabel="(tax) => tax.code + ' - ' + tax.name" class="form-control" :class="[
                            { 'is-valid': !errors[0] },
                            { 'is-invalid': errors[0] },
                          ]" placeholder="~~ Pilih Rekening Pajak ~~" @input="setFare"></v-select>
                        <div class="text-danger invalid-feedback" style="display: block" v-if="errors[0]">{{ errors[0] }}
                        </div>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>

                <div v-if="form.file">
                  <div class="form-group">
                    <button type="button" color="success" @click="
                      downloadFile('file')
                      " size="small">
                      Download Bukti Pembayaran
                    </button>
                    <button type="button" style="margin-left: 5px" color="danger" @click="
                      deleteFile('file')
                      " size="small">
                      Hapus Bukti Pembayaran
                    </button>
                  </div>
                </div>
                <template v-else>
                  <ValidationProvider name="Bukti Pembayaran Pajak harus di upload" rules="required"
                    v-slot="{ validate, errors }">
                    <div class="form-group">
                      <label>Bukti Pembayaran</label>
                      <input type="file" class="form-control" @change="
                        uploadFiles(
                          $event,
                          'file'
                        ) || validate($event)
                        " />
                      <span class="text-danger text-sm" v-show="errors[0]">{{
                        errors[0]
                      }}</span>
                    </div>
                  </ValidationProvider>
                </template>
                <div class="row">
                  <div class="col-md-6 col-sm-12">
                    <div class="form-group">
                      <label>Pajak</label>

                      <input type="text" :value="parseInt(form.fare) + '%'" class="form-control text-right"
                        placeholder="Pajak" readonly />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 col-sm-12">
                    <div class="form-group">
                      <ValidationProvider name="Omzet" rules="required" v-slot="{ errors }">
                        <label>Omzet</label>
                        <money v-model="form.omzet" v-bind="money" class="form-control text-right" placeholder="Omzet">
                        </money>
                        <div class="text-danger invalid-feedback" style="display: block" v-if="errors[0]">{{ errors[0] }}
                        </div>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12 col-sm-12">
                    <div class="form-group">
                      <ValidationProvider name="Pajak yang harus dibayar" rules="required" v-slot="{ errors }">
                        <label>Pajak yang Harus Dibayar</label>
                        <money v-model="form.total_tax" v-bind="money" class="form-control text-right"
                          placeholder="Pajak Yang harus dibayar" readonly></money>
                        <div class="text-danger invalid-feedback" style="display: block" v-if="errors[0]">{{ errors[0] }}
                        </div>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- / PAGE CONTENT ENDS -->
          <div class="row float-right">
            <div class="col-md-12 col-sm-12">
              <template v-if="isBusy">
                <pulse-loader :loading="isBusy" :color="'#d7f6e8'"></pulse-loader>
                <strong>Loading...</strong>
              </template>
              <base-button v-else type="success" nativeType="submit" icon="ni ni-send">{{ edit ? "Update" : "Simpan"
              }}</base-button>
              <base-button type="warning" @click="modals.modal1 = false">Tutup</base-button>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </modal>
</template>
<script>
import Modal from "@/components/Modal.vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import axios from "axios";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import { Money } from "v-money";
import Datepicker from "vuejs-datepicker";
import { BTable } from "bootstrap-vue";

export default {
  components: {
    Modal,
    PulseLoader,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    Money,
    Datepicker,
    BTable,
  },
  watch: {
    "form.omzet": function () {
      this.form.total_tax = (this.form.omzet * this.form.fare) / 100;
    },
    "form.fare": function () {
      this.form.total_tax = (this.form.omzet * this.form.fare) / 100;
    },
  },
  props: ['year'],
  data() {
    return {
      modals: {
        modal1: false,
      },
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "Rp. ",
        suffix: "",
        precision: 2,
        masked: false,
      },
      form: {
        registration_id: null,
        tax_id: null,
        omzet: 0,
        total_tax: 0,
        fare: 0,
        file: null,
        registration: {},
        tax: {}
      },
      isBusy: false,
      registrations: [],
      taxes: [],
      error_msg: [],
      edit: false,
      fare: 0,
      selectedTaxes: [],
    };
  },
  methods: {
    async uploadFiles(event, name) {
      const files = event.target.files;
      const file = new FormData();
      file.append("file", files[0]);
      let fileName = files[0]["name"];
      file.append(
        "filename",
        name + "." + fileName.substr(fileName.lastIndexOf(".") + 1)
      );
      if (files[0]["size"] > 1024 * 1024 * 2) {
        alert("File terlalu besar harus kurang dari 2MB (> 2MB)");
        return;
      }
      if (
        files[0]["type"] != "image/png" &&
        files[0]["type"] != "image/jpeg" &&
        files[0]["type"] != "application/pdf"
      ) {
        alert("File yang Anda upload bukan PDF/Image");
        return;
      }
      try {
        let { data } = await axios.post("/api/v1/upload", file);
        this.form[name] = data;
      } catch (error) {
        // console.log(error);
        this.form[name] = null;
      } finally {
      }
    },
    downloadFile(name) {
      axios({
        url: "/api/v1/download_pdf?filename=" + this.form[name], //your url
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute("download", this.form[name]); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    },
    deleteFile(name) {
      this.form[name] = null;
    },
    showModal() {
      this.items = [];
      this.edit = false;
      this.modals.modal1 = true;
      this.form.registration_id = null;
      this.form.fare = 0;
      this.form.tax_id = null;
      this.form.omzet = 0;
      this.form.total_tax = 0;
      this.selectedTaxes = [];
      this.form.file = null;
      this.get_registrations();
    },
    hideModal() {
      this.modals.modal1 = false;
    },
    async submit() {
      this.$emit("addData", this.form);
      this.hideModal();
      this.isBusy = false;
    },
    async get_registrations() {
      try {
        this.registrations = [];
        this.isBusy = true;
        let { data } = await axios.get(
          "/api/v1/registrations?mode=1"
        );
        data.forEach(element => {
          if (element.business_id == 9)
            this.registrations.push(element);
        });
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
      } finally {
        this.isBusy = false;
      }
    },
    async get_texes() {
      let registration = this.registrations.find(r => r.id == this.form.registration_id)
      let code = '1109'
      try {
        this.taxes = [];
        this.isBusy = true;
        let { data } = await axios.get(
          "/api/v1/taxes?code=" +
          code +
          "&year=" +
          this.year
        );
        this.taxes = data;
        this.form.registration = registration
      } catch (error) {
      } finally {
        this.isBusy = false;
      }
    },
    setFare(items) {
      this.fare = items.fare == null ? 0 : items.fare;
      this.form.tax_id = items.id;
      this.form.fare = items.fare;
      this.form.tax = items
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-dialog {
  max-width: 80% !important;
  margin: 1.75rem auto;
}

.uploader-example {
  padding: 15px;
  font-size: 12px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
}

.uploader-example .uploader-btn {
  margin-right: 4px;
}

.uploader-example .uploader-list {
  max-height: 440px;
  overflow: auto;
  overflow-x: hidden;
  overflow-y: auto;
}

.has-success:after {
  margin-top: 30px;
  content: "\EA26";
  color: #1d8357;
  background-color: #69deac;
}

.has-danger:after {
  margin-top: 30px;
  content: "\EA53";
  color: #db2d05;
  background-color: #fda08b;
}
</style>